import { forOwn } from 'lodash'

export default obj =>
  forOwn(obj, (value, key) => {
    document.documentElement.style.setProperty(key, value)
  })
